
import { defineComponent } from "vue";
import { MainAppController } from "../../controllers/MainAppController";

export default defineComponent({
  name: "ToastLoginApproval",
  setup() {
    return {
      data: MainAppController.snackbarData
    };
  }
});
